module.exports = __webpack_public_path__ + "static/graphql-818587bafb11ec1c02657d188ca99574.png";